import { EmailReviewListItemContent } from './components/listItemContent/EmailReviewListItemContent'
import { EmailReviewContent } from './components/reviewContent/EmailReviewContent'

export const emailReviewManualTask = {
  reviewContent: EmailReviewContent,
  listItemContent: EmailReviewListItemContent
}

export * as EmailReviewTask from './types'
